import { getSrc } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

// Styles
import { colors } from '../../styles/vars/colors.style'
import Button from '../Button'
import Spacer from '../Spacer'
import { TextBody } from '../TextStyles'
import AnimateSlideIn from '../animation/AnimateSlideIn'
import {
  WayToBookCardBG,
  WayToBookCardFooter,
  WayToBookCardHeader,
  WayToBookCardItalicTitle,
  WayToBookCardMain,
  WayToBookCardNormalTitle,
  WayToBookCardWrapper,
} from './index.style'

const WayToBookCard = ({
  image,
  headingItalic,
  headingNormal,
  text,
  cta,
  delay,
  id,
}) => {
  const imageSource = getSrc(image.gatsbyImageData)

  return (
    <WayToBookCardWrapper href={cta.externalLink} aria-label={cta.label}>
      <AnimateSlideIn id={id} delay={delay}>
        <WayToBookCardMain>
          <WayToBookCardBG bg={imageSource} />

          <WayToBookCardHeader>
            <WayToBookCardItalicTitle>{headingItalic}</WayToBookCardItalicTitle>
            <WayToBookCardNormalTitle>{headingNormal}</WayToBookCardNormalTitle>
          </WayToBookCardHeader>

          <WayToBookCardFooter>
            <TextBody maxWidth={18}>{text}</TextBody>
            <Spacer size={[32, 30]} />
            <Button inline variant="fill" color={colors.orange}>
              {cta.label}
            </Button>
          </WayToBookCardFooter>
        </WayToBookCardMain>
      </AnimateSlideIn>
    </WayToBookCardWrapper>
  )
}

WayToBookCard.propTypes = {
  image: PropTypes.object,
  headingItalic: PropTypes.string,
  headingNormal: PropTypes.string,
  text: PropTypes.string,
  delay: PropTypes.number,
  cta: PropTypes.object,
}

export default WayToBookCard
